module.exports = __webpack_public_path__ + "img/golf_cos4.f51c81af.png";